const common = {
  width: 18,
  height: 18,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.8,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

export function IconUser() {
  return (
    <svg {...common}>
      <circle cx="12" cy="8" r="3.4" />
      <path d="M5 20c1.4-3.8 4-5.6 7-5.6s5.6 1.8 7 5.6" />
    </svg>
  );
}

export function IconMail() {
  return (
    <svg {...common}>
      <rect x="3.5" y="5.5" width="17" height="13" rx="2" />
      <path d="M4 6.5l8 6 8-6" />
    </svg>
  );
}

export function IconLink() {
  return (
    <svg {...common}>
      <path d="M9.5 14.5l5-5" />
      <path d="M11 7.5l1.4-1.4a3.6 3.6 0 015 5L16 12.5" />
      <path d="M13 16.5l-1.4 1.4a3.6 3.6 0 01-5-5L8 11.5" />
    </svg>
  );
}

export function IconUsers() {
  return (
    <svg {...common}>
      <circle cx="9" cy="8" r="3" />
      <path d="M3.5 19c1.1-3.3 3.3-4.9 5.5-4.9s4.4 1.6 5.5 4.9" />
      <circle cx="17" cy="8.5" r="2.3" />
      <path d="M15.5 14.3c2.5.3 4 1.9 5 4.7" />
    </svg>
  );
}

export function IconHistory() {
  return (
    <svg {...common}>
      <path d="M4 12a8 8 0 118 8" />
      <path d="M4 12V7" />
      <path d="M4 12h5" />
      <path d="M12 8v4l3 2" />
    </svg>
  );
}

export function IconTools() {
  return (
    <svg {...common}>
      <path d="M14.5 6.5a3.5 3.5 0 00-4.6 4.4L4 16.8V20h3.2l5.9-5.9a3.5 3.5 0 004.4-4.6l-2.6 2.6-2-2z" />
    </svg>
  );
}

export function IconMessage() {
  return (
    <svg {...common}>
      <path d="M4 5.5h16v10H9l-4 3.5v-3.5H4z" />
    </svg>
  );
}

export function IconNote() {
  return (
    <svg {...common}>
      <path d="M6 4h9l4 4v12H6z" />
      <path d="M15 4v4h4" />
      <path d="M9 13h7M9 16.5h7" />
    </svg>
  );
}

export function IconGlobe() {
  return (
    <svg {...common}>
      <circle cx="12" cy="12" r="8" />
      <path d="M4 12h16M12 4a12.6 12.6 0 010 16M12 4a12.6 12.6 0 000 16" />
    </svg>
  );
}

export function IconCalendar() {
  return (
    <svg {...common}>
      <rect x="4" y="5.5" width="16" height="14" rx="2" />
      <path d="M4 10h16M8 3.5v3M16 3.5v3" />
    </svg>
  );
}

export function IconChevronLeft() {
  return (
    <svg {...common}>
      <path d="M14.5 5.5L8 12l6.5 6.5" />
    </svg>
  );
}

export function IconChevronRight() {
  return (
    <svg {...common}>
      <path d="M9.5 5.5L16 12l-6.5 6.5" />
    </svg>
  );
}
